import { render, staticRenderFns } from "./TenderKeywords.vue?vue&type=template&id=241fb235"
import script from "./TenderKeywords.vue?vue&type=script&lang=js"
export * from "./TenderKeywords.vue?vue&type=script&lang=js"
import style0 from "./TenderKeywords.vue?vue&type=style&index=0&id=241fb235&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports